import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpdatesSocialShareComponent } from './components/updates-social-share/updates-social-share.component';
import { FbShareModule } from '../fb-share/fb-share.module';
import { WhatsappShareModule } from '../whatsapp-share/whatsapp-share.module';

@NgModule({
  declarations: [UpdatesSocialShareComponent],
  imports: [
    CommonModule,
    FbShareModule,
    WhatsappShareModule
  ],
  exports: [UpdatesSocialShareComponent]
})
export class UpdatesSocialShareModule { }
